/*
 * Kremi (10-17): ürün sayfası güven satırının gönderim öğesi — kargoya ne zaman çıkacağını DÜRÜSTÇE söyler.
 * Kural (Zeynep): kargo günleri Pazartesi–Cumartesi (`days`), Pazar ve resmî tatil/arife (`holidays`,
 * `half-days`) kargo yok. Kesim `cutoff` (16:00).
 *   - kargo günü, kesimden `window` saatten fazla önce → sunucunun bastığı sabit metin ("Aynı gün kargo / 16:00'a kadar")
 *   - kargo günü, son `window` saat            → "Bugün kargoda / ● 02:14:05 kaldı"
 *   - kesim geçti / kargo günü değil            → "Yarın kargoda" ya da "Pazartesi kargoda" + tarih
 * Saat HER ZAMAN İstanbul'a göre (ziyaretçinin cihaz saat dilimi değil). JS yoksa sabit metin kalır.
 */
const TZ = 'Europe/Istanbul';
const parts = new Intl.DateTimeFormat('en-GB', {
  timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
});

function istanbulNow() {
  const p = Object.fromEntries(parts.formatToParts(new Date()).map((x) => [x.type, x.value]));
  return { y: +p.year, m: +p.month, d: +p.day, seconds: (+p.hour) * 3600 + (+p.minute) * 60 + (+p.second) };
}

// İstanbul takvim günü + k gün → o günün öğlen UTC'si (saat dilimi kaymasından bağımsız gün aritmetiği).
const dayAt = (now, k) => new Date(Date.UTC(now.y, now.m - 1, now.d + k, 12));
const iso = (date) => date.toISOString().slice(0, 10);
const pad = (n) => String(n).padStart(2, '0');

class KremiShipCountdown extends HTMLElement {
  connectedCallback() {
    this.cutoff = Number(this.getAttribute('cutoff') || 16) * 3600;
    this.window = Number(this.getAttribute('window') || 3) * 3600;
    this.days = (this.getAttribute('days') || '1,2,3,4,5,6').split(',').map(Number);
    const list = (name) => (this.getAttribute(name) || '').split(',').map((x) => x.trim()).filter(Boolean);
    this.closed = new Set([...list('holidays'), ...list('half-days')]);
    this.els = {
      static: this.querySelector('.kremi-trust-line__static'),
      live: this.querySelector('.kremi-trust-line__live'),
      next: this.querySelector('.kremi-trust-line__next')
    };
    this.timerEl = this.querySelector('[data-timer]');
    if (!this.els.static || !this.els.live || !this.els.next || !this.timerEl) return;
    this.nextTitle = this.els.next.querySelector('.kremi-trust-line__title');
    this.nextSub = this.els.next.querySelector('.kremi-trust-line__sub');
    const lang = document.documentElement.lang || 'tr';
    this.fmtWeekday = new Intl.DateTimeFormat(lang, { weekday: 'long', timeZone: 'UTC' });
    this.fmtDate = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'long', timeZone: 'UTC' });
    this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.state = 'static';
    this.tick = this.tick.bind(this);
    // Sayfa açılır açılmaz değişse de GÖRÜLSÜN: önce sabit metin, kısa süre sonra kayarak yeni metin.
    // Hareket azaltmada beklemeden, animasyonsuz.
    this.start = setTimeout(() => {
      this.tick();
      this.interval = setInterval(this.tick, 1000);
    }, this.reduced ? 0 : 1200);
  }

  disconnectedCallback() {
    clearTimeout(this.start);
    clearInterval(this.interval);
  }

  isShipDay(date) {
    return this.days.includes(date.getUTCDay()) && !this.closed.has(iso(date));
  }

  tick() {
    const now = istanbulNow();
    const shipToday = this.isShipDay(dayAt(now, 0));
    if (shipToday && now.seconds < this.cutoff) {
      const left = this.cutoff - now.seconds;
      if (left > this.window) return this.show('static');
      this.timerEl.textContent = `${pad(Math.floor(left / 3600))}:${pad(Math.floor((left % 3600) / 60))}:${pad(left % 60)}`;
      return this.show('live');
    }
    // Kesim geçti ya da bugün kargo yok: ilk kargo gününü bul (en çok 2 hafta ileri — bayram + hafta sonu).
    for (let k = 1; k <= 14; k += 1) {
      const date = dayAt(now, k);
      if (!this.isShipDay(date)) continue;
      const key = iso(date);
      if (this.nextKey !== key) {
        this.nextKey = key;
        // "Yarın" yalnız bugün kargo günüyse (16:00 sonrası); Pazar/tatilde gün adı: "Pazartesi kargoda" (Zeynep).
        const day = k === 1 && shipToday ? this.getAttribute('tomorrow') : this.fmtWeekday.format(date);
        this.nextTitle.textContent = (this.getAttribute('next-title') || '[[day]]').replace('[[day]]', day);
        this.nextSub.textContent = this.fmtDate.format(date);
      }
      return this.show('next');
    }
    return this.show('static');
  }

  show(state) {
    if (state === this.state) return;
    this.state = state;
    for (const [name, el] of Object.entries(this.els)) el.hidden = name !== state;
    if (!this.reduced) {
      const el = this.els[state];
      el.classList.remove('is-entering');
      void el.offsetWidth;
      el.classList.add('is-entering');
    }
  }
}

if (!customElements.get('kremi-ship-countdown')) {
  customElements.define('kremi-ship-countdown', KremiShipCountdown);
}
